import { EMagnitudeType } from '@web/entities/measurement/model/enums/magnitude-type.enum'
import { EOctaveType } from '@web/entities/measurement/model/enums/octave.enum'

export const magnitudeTypeMap = {
  [EMagnitudeType.RMS]: 'СКЗ',
  [EMagnitudeType.POWER]: 'Мощность'
} as const

export const octaveTypeMap = {
  [EOctaveType.TWO]: '2',
  [EOctaveType.THIRD]: '1/3',
  [EOctaveType.ONE]: '1'
} as const
